import React from 'react';
import { Image, Modal, Spinner, Table } from 'react-bootstrap';
import moment from 'moment';
import BirthsModalButtons from './BirthsModalButtons';
import Icon from '../../Icons';

const BirthsSideModal = ({
  show,
  onHide,
  data,
  title,
  onPrevMonth,
  onNextMonth,
  onCurrentMonth,
  showMonthControls,
  showPanelSpinner
}) => {
  const formatBirthdate = value => {
    if (!value) return '';
    const parsed = moment(value, 'YYYY-MM-DD', true);
    if (!parsed.isValid()) return value;
    const formatted = parsed
      .year(moment().year())
      .locale('es')
      .format('ddd DD');
    const normalized = formatted
      .replace(/[.,]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return normalized.replace(/^\p{L}/u, m => m.toUpperCase());
  };

  return (
    <>
      <Modal show={show} onHide={onHide} dialogClassName="modal-right" className="help-subcategories-modal" backdrop>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">
            <div style={{ color: 'rgb(43, 180, 143)', fontWeight: 'bold', fontSize: '1.1rem' }}>{title}</div>
            <BirthsModalButtons
              showMonthControls={showMonthControls}
              onPrevMonth={onPrevMonth}
              onNextMonth={onNextMonth}
              onCurrentMonth={onCurrentMonth}
              onHide={onHide}
              show={show}
             />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showPanelSpinner ? (
            <div className="d-flex justify-content-center py-3">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="table-responsive">
              <Table borderless hover>
                <thead>
                  <tr>
                    <th className="text-center align-middle" colSpan={2}>
                      Trabajador
                    </th>
                    <th className="text-center align-middle">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(item => (
                    <tr key={item.id}>
                      <td className="align-middle">
                        <div
                          className="avatar employee d-flex align-items-center"
                          style={{ width: 30, height: 30, marginRight: '10px' }}
                        >
                          <div
                            className={item.file_info.file_url ? 'content' : 'empty content'}
                            style={{ width: 30, height: 30 }}
                          >
                            {item.file_info.file_url ? (
                              <Image
                                src={item.file_info.file_url}
                                fluid
                                roundedCircle
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              />
                            ) : (
                              <Icon icon="camera" />
                            )}
                          </div>
                        </div>
                      </td>
                      <th className="align-middle">{item.full_name}</th>
                      <th className="text-center align-middle">{formatBirthdate(item.birthdate)}</th>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BirthsSideModal;
